import { connect } from 'react-redux';
import { clearStore } from '../actions/user';
import { openPopup } from '../actions/popup';
import UserLogin from './UserLogin';
import UserProfile from './UserProfile';
import { Fragment } from 'react';

function UnderMenu({ user, lang, openPopup, fromUnknownPage }) {
  const handleClick = () => {
    if (user.status !== 'confirmed') {
      openPopup(lang === 'ru' ? 'Авторизация' : 'Authorization', <UserLogin lang={lang} />);
    } else {
      openPopup(lang === 'ru' ? 'Вы вошли как:' : 'You are logged in as:', <UserProfile lang={lang} />)
    }
  }
  return (
    user.status === 'unregistered' ?
    <div className={`auth-under-menu hover ${fromUnknownPage === true ? 'unknown' : ''}`} onClick={handleClick}>
        <a><p className="auth-label">{lang === 'ru' ? 'Войти' : 'Log in'}</p></a>
    </div>
    : user.status === 'confirmed' ?
    <div className={`auth-under-menu hover ${fromUnknownPage === true ? 'unknown' : ''}`} onClick={handleClick}>
        <a><p className="auth-label">{user.data.name}</p></a>
    </div>
    : <Fragment/>
  );
}

const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps, { clearStore, openPopup })(UnderMenu)